import React from 'react';

const ProcessPayrollModal = ({
    showProcessModal,
    setShowProcessModal,
    selectedPayroll,
    handleProcessConfirm,
    getStatusBadge
}) => {
    if (!showProcessModal || !selectedPayroll) return null;

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header bg-success text-white">
                        <h5 className="modal-title">
                            <i className="bi bi-play-circle me-2"></i>
                            Process Payroll
                        </h5>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowProcessModal(false)}
                        ></button>
                    </div>

                    <div className="modal-body">
                        <div className="alert alert-info" role="alert">
                            <i className="bi bi-info-circle-fill me-2"></i>
                            This will process payroll for the selected period.
                        </div>

                        <p>Are you sure you want to process the following payroll period?</p>

                        <div className="card border-0 bg-light">
                            <div className="card-body">
                                <h6 className="fw-bold">Payroll Period: {selectedPayroll.month_year}</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <small className="text-muted d-block">Period</small>
                                        <strong>
                                            {new Date(selectedPayroll.from_date).toLocaleDateString()} to {new Date(selectedPayroll.to_date).toLocaleDateString()}
                                        </strong>
                                    </div>
                                    <div className="col-md-6">
                                        <small className="text-muted d-block">Status</small>
                                        <span className={`badge ${getStatusBadge(selectedPayroll.status)}`}>
                                            {selectedPayroll.status}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="alert alert-warning mt-3" role="alert">
                            <i className="bi bi-exclamation-triangle me-2"></i>
                            <strong>Note:</strong> This action will calculate salaries, deductions, and generate payroll reports.
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light border-secondary-subtle"
                            onClick={() => setShowProcessModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleProcessConfirm}
                        >
                            <i className="bi bi-play-circle me-2"></i>
                            Process Payroll
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProcessPayrollModal;